import React, { useState } from 'react';
import './App.css';
import CompaniesTable from './components/CompaniesTable';
import LoadingSpinner from './components/LoadingSpinner';
import apiService from './services/apiService';

const COUNTRY_STATES = {
  'United States': [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
    'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia',
    'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
    'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
    'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
    'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
    'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina',
    'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia',
    'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
  ],
  'Canada': [
    'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick',
    'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia',
    'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon'
  ],
  'India': [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
    'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
    'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
    'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
    'Chandigarh', 'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Puducherry'
  ],
  'Australia': [
    'Australian Capital Territory', 'New South Wales', 'Northern Territory',
    'Queensland', 'South Australia', 'Tasmania', 'Victoria', 'Western Australia'
  ],
  'Brazil': [
    'Acre', 'Alagoas', 'Amapá', 'Amazonas', 'Bahia', 'Ceará', 'Distrito Federal',
    'Espírito Santo', 'Goiás', 'Maranhão', 'Mato Grosso', 'Mato Grosso do Sul',
    'Minas Gerais', 'Pará', 'Paraíba', 'Paraná', 'Pernambuco', 'Piauí',
    'Rio de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondônia',
    'Roraima', 'Santa Catarina', 'São Paulo', 'Sergipe', 'Tocantins'
  ],
  'Germany': [
    'Baden-Württemberg', 'Bavaria', 'Berlin', 'Brandenburg', 'Bremen',
    'Hamburg', 'Hesse', 'Lower Saxony', 'Mecklenburg-Vorpommern',
    'North Rhine-Westphalia', 'Rhineland-Palatinate', 'Saarland', 'Saxony',
    'Saxony-Anhalt', 'Schleswig-Holstein', 'Thuringia'
  ],
  'United Kingdom': ['England', 'Northern Ireland', 'Scotland', 'Wales'],
  'Mexico': [
    'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche',
    'Chiapas', 'Chihuahua', 'Coahuila', 'Colima', 'Durango', 'Guanajuato',
    'Guerrero', 'Hidalgo', 'Jalisco', 'Mexico City', 'Mexico State',
    'Michoacán', 'Morelos', 'Nayarit', 'Nuevo León', 'Oaxaca', 'Puebla',
    'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora',
    'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'
  ],
  'China': [
    'Anhui', 'Beijing', 'Chongqing', 'Fujian', 'Gansu', 'Guangdong', 'Guangxi',
    'Guizhou', 'Hainan', 'Hebei', 'Heilongjiang', 'Henan', 'Hong Kong',
    'Hubei', 'Hunan', 'Inner Mongolia', 'Jiangsu', 'Jiangxi', 'Jilin',
    'Liaoning', 'Macau', 'Ningxia', 'Qinghai', 'Shaanxi', 'Shandong',
    'Shanghai', 'Shanxi', 'Sichuan', 'Tianjin', 'Tibet', 'Xinjiang',
    'Yunnan', 'Zhejiang'
  ],
  'France': [
    'Auvergne-Rhône-Alpes', 'Bourgogne-Franche-Comté', 'Bretagne',
    'Centre-Val de Loire', 'Corse', 'Grand Est', 'Hauts-de-France',
    'Île-de-France', 'Normandie', 'Nouvelle-Aquitaine', 'Occitanie',
    'Pays de la Loire', "Provence-Alpes-Côte d'Azur"
  ],
  'Spain': [
    'Andalusia', 'Aragon', 'Asturias', 'Balearic Islands', 'Basque Country',
    'Canary Islands', 'Cantabria', 'Castile and León', 'Castile-La Mancha',
    'Catalonia', 'Extremadura', 'Galicia', 'La Rioja', 'Madrid', 'Murcia',
    'Navarre', 'Valencian Community'
  ],
  'Italy': [
    'Abruzzo', 'Aosta Valley', 'Apulia', 'Basilicata', 'Calabria', 'Campania',
    'Emilia-Romagna', 'Friuli-Venezia Giulia', 'Lazio', 'Liguria', 'Lombardy',
    'Marche', 'Molise', 'Piedmont', 'Sardinia', 'Sicily',
    'Trentino-Alto Adige', 'Tuscany', 'Umbria', 'Veneto'
  ],
  'Japan': [
    'Aichi', 'Akita', 'Aomori', 'Chiba', 'Ehime', 'Fukui', 'Fukuoka',
    'Fukushima', 'Gifu', 'Gunma', 'Hiroshima', 'Hokkaido', 'Hyogo',
    'Ibaraki', 'Ishikawa', 'Iwate', 'Kagawa', 'Kagoshima', 'Kanagawa',
    'Kochi', 'Kumamoto', 'Kyoto', 'Mie', 'Miyagi', 'Miyazaki', 'Nagano',
    'Nagasaki', 'Nara', 'Niigata', 'Oita', 'Okayama', 'Okinawa', 'Osaka',
    'Saga', 'Saitama', 'Shiga', 'Shimane', 'Shizuoka', 'Tochigi',
    'Tokushima', 'Tokyo', 'Tottori', 'Toyama', 'Wakayama', 'Yamagata',
    'Yamaguchi', 'Yamanashi'
  ],
  'South Korea': [
    'Busan', 'Chungcheongbuk-do', 'Chungcheongnam-do', 'Daegu', 'Daejeon',
    'Gangwon-do', 'Gwangju', 'Gyeonggi-do', 'Gyeongsangbuk-do',
    'Gyeongsangnam-do', 'Incheon', 'Jeju', 'Jeollabuk-do', 'Jeollanam-do',
    'Sejong', 'Seoul', 'Ulsan'
  ],
  'South Africa': [
    'Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo',
    'Mpumalanga', 'North West', 'Northern Cape', 'Western Cape'
  ],
  'Saudi Arabia': [
    'Al Bahah', 'Al Hudud ash Shamaliyah', 'Al Jawf', 'Al Madinah al Munawwarah',
    'Al Qasim', 'Ar Riyad', 'Ash Sharqiyah', 'Asir', "Ha'il", 'Jizan',
    'Makkah al Mukarramah', 'Najran', 'Tabuk'
  ],
  'United Arab Emirates': [
    'Abu Dhabi', 'Ajman', 'Dubai', 'Fujairah', 'Ras Al Khaimah', 'Sharjah',
    'Umm Al Quwain'
  ],
  'Nigeria': [
    'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 'Benue',
    'Borno', 'Cross River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu',
    'FCT (Abuja)', 'Gombe', 'Imo', 'Jigawa', 'Kaduna', 'Kano', 'Katsina',
    'Kebbi', 'Kogi', 'Kwara', 'Lagos', 'Nasarawa', 'Niger', 'Ogun',
    'Ondo', 'Osun', 'Oyo', 'Plateau', 'Rivers', 'Sokoto', 'Taraba',
    'Yobe', 'Zamfara'
  ],
  'Pakistan': [
    'Azad Kashmir', 'Balochistan', 'Gilgit-Baltistan',
    'Islamabad Capital Territory', 'Khyber Pakhtunkhwa', 'Punjab', 'Sindh'
  ],
  'Argentina': [
    'Buenos Aires', 'Buenos Aires Province', 'Catamarca', 'Chaco', 'Chubut',
    'Córdoba', 'Corrientes', 'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa',
    'La Rioja', 'Mendoza', 'Misiones', 'Neuquén', 'Río Negro', 'Salta',
    'San Juan', 'San Luis', 'Santa Cruz', 'Santa Fe', 'Santiago del Estero',
    'Tierra del Fuego', 'Tucumán'
  ]
};

const REGION_COUNTRIES = {
  'North America': [
    'Canada', 'Mexico', 'United States'
  ],
  'Europe': [
    'Albania', 'Austria', 'Belarus', 'Belgium', 'Bosnia and Herzegovina',
    'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'Estonia',
    'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Iceland', 'Ireland',
    'Italy', 'Kosovo', 'Latvia', 'Liechtenstein', 'Lithuania', 'Luxembourg',
    'Malta', 'Moldova', 'Montenegro', 'Netherlands', 'North Macedonia',
    'Norway', 'Poland', 'Portugal', 'Romania', 'Russia', 'Serbia', 'Slovakia',
    'Slovenia', 'Spain', 'Sweden', 'Switzerland', 'Ukraine', 'United Kingdom'
  ],
  'APAC': [
    'Australia', 'Bangladesh', 'Bhutan', 'Brunei', 'Cambodia', 'China',
    'Fiji', 'Hong Kong', 'India', 'Indonesia', 'Japan', 'Laos', 'Macau',
    'Malaysia', 'Maldives', 'Mongolia', 'Myanmar', 'Nepal', 'New Zealand',
    'Pakistan', 'Papua New Guinea', 'Philippines', 'Singapore', 'South Korea',
    'Sri Lanka', 'Taiwan', 'Thailand', 'Vietnam'
  ],
  'LA': [
    'Argentina', 'Belize', 'Bolivia', 'Brazil', 'Chile', 'Colombia',
    'Costa Rica', 'Cuba', 'Dominican Republic', 'Ecuador', 'El Salvador',
    'Guatemala', 'Guyana', 'Haiti', 'Honduras', 'Jamaica', 'Nicaragua',
    'Panama', 'Paraguay', 'Peru', 'Puerto Rico', 'Suriname',
    'Trinidad and Tobago', 'Uruguay', 'Venezuela'
  ],
  'MEA': [
    'Algeria', 'Angola', 'Bahrain', 'Benin', 'Botswana', 'Burkina Faso',
    'Burundi', 'Cameroon', 'Chad', 'Congo', "Côte d'Ivoire",
    'Democratic Republic of Congo', 'Djibouti', 'Egypt', 'Eritrea', 'Ethiopia',
    'Gabon', 'Ghana', 'Guinea', 'Iran', 'Iraq', 'Israel', 'Jordan', 'Kenya',
    'Kuwait', 'Lebanon', 'Libya', 'Madagascar', 'Malawi', 'Mali', 'Mauritius',
    'Morocco', 'Mozambique', 'Namibia', 'Niger', 'Nigeria', 'Oman', 'Qatar',
    'Rwanda', 'Saudi Arabia', 'Senegal', 'Sierra Leone', 'Somalia',
    'South Africa', 'South Sudan', 'Sudan', 'Syria', 'Tanzania', 'Tunisia',
    'Uganda', 'United Arab Emirates', 'Yemen', 'Zambia', 'Zimbabwe'
  ]
};

function App() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [industry, setIndustry] = useState('');
  const [region, setRegion] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [keywords, setKeywords] = useState('');
  const [excludeKeywords, setExcludeKeywords] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [revenueSort, setRevenueSort] = useState(null); // null | 'asc' | 'desc'
  const [pagination, setPagination] = useState({
    page: 1, perPage: 10, totalRecords: 0, totalPages: 0
  });
  const [exportLoading, setExportLoading] = useState(false);
  const [exportProgress, setExportProgress] = useState({ fetched: 0, total: 0 });
  // chunks: [{ chunkNum, totalChunks, records, status: 'ready'|'downloaded' }]
  const [chunks, setChunks] = useState([]);
  const [baseFilename, setBaseFilename] = useState('');

  const parseList = (raw) => raw.split(',').map(k => k.trim()).filter(Boolean);

  // Parse revenue string like "$5M", "$1.2B", "$300K" → number for sorting
  const parseRevenueValue = (str) => {
    if (!str || str === 'N/A') return -1;
    const s = str.replace(/[$,\s]/g, '').toUpperCase();
    if (s.endsWith('B')) return parseFloat(s) * 1e9;
    if (s.endsWith('M')) return parseFloat(s) * 1e6;
    if (s.endsWith('K')) return parseFloat(s) * 1e3;
    return parseFloat(s) || -1;
  };

  const handleRevenueSort = () => {
    setRevenueSort(prev =>
      prev === null ? 'asc' : prev === 'asc' ? 'desc' : null
    );
  };

  // Filter by search query, then sort by revenue
  const displayedCompanies = (() => {
    let list = companies;
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      list = list.filter(c => (c['Company Name'] || '').toLowerCase().includes(q));
    }
    if (revenueSort) {
      list = [...list].sort((a, b) => {
        const diff = parseRevenueValue(a['Revenue ($)']) - parseRevenueValue(b['Revenue ($)']);
        return revenueSort === 'asc' ? diff : -diff;
      });
    }
    return list;
  })();

  const fetchCompanies = async (page = 1, perPage = pagination.perPage) => {
    try {
      setLoading(true);
      setError(null);
      setSearchQuery('');
      setRevenueSort(null);
      const response = await apiService.getCompanies(
        page, perPage, industry, parseList(keywords), parseList(excludeKeywords), region, country, state
      );
      setCompanies(response.data);
      setPagination({
        page: response.pagination.page,
        perPage: response.pagination.perPage,
        totalRecords: response.pagination.totalRecords,
        totalPages: response.pagination.totalPages
      });
    } catch (err) {
      setError(err.message || 'Failed to fetch companies');
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      fetchCompanies(newPage, pagination.perPage);
    }
  };

  const handlePerPageChange = (e) => fetchCompanies(1, parseInt(e.target.value));

  // Prepare all chunks into memory — does NOT auto-download
  const handlePrepareChunks = async () => {
    if (pagination.totalRecords === 0) {
      alert('Fetch data first before preparing chunks.');
      return;
    }
    const filename = `${(industry || 'companies').replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}`;
    setBaseFilename(filename);
    setChunks([]);
    setExportLoading(true);
    setExportProgress({ fetched: 0, total: pagination.totalRecords });

    try {
      await apiService.fetchAllForExport(
        industry,
        parseList(keywords),
        parseList(excludeKeywords),
        (fetched, total) => setExportProgress({ fetched, total }),
        ({ chunkNum, totalChunks, records }) => {
          setChunks(prev => [
            ...prev,
            { chunkNum, totalChunks, records, status: 'ready' }
          ]);
        },
        region,
        country,
        state
      );
    } catch (err) {
      alert(`Failed to prepare chunks: ${err.message}`);
    } finally {
      setExportLoading(false);
    }
  };

  // Download a specific chunk on demand
  const handleDownloadChunk = (chunkNum) => {
    const chunk = chunks.find(c => c.chunkNum === chunkNum);
    if (!chunk) return;
    const totalChunks = chunk.totalChunks;
    const filename = `${baseFilename}_chunk_${chunkNum}_of_${totalChunks}.csv`;
    apiService.downloadCSV(apiService.convertToCSV(chunk.records), filename);
    setChunks(prev => prev.map(c =>
      c.chunkNum === chunkNum ? { ...c, status: 'downloaded' } : c
    ));
  };

  const handleDownloadAllChunks = () => {
    chunks.forEach(c => {
      if (c.status !== 'downloaded') handleDownloadChunk(c.chunkNum);
    });
  };

  const downloadedCount = chunks.filter(c => c.status === 'downloaded').length;
  const readyCount = chunks.filter(c => c.status === 'ready').length;
  const totalChunkRecords = chunks.reduce((sum, c) => sum + c.records.length, 0);
  const pct = exportProgress.total > 0
    ? Math.min(Math.round((exportProgress.fetched / exportProgress.total) * 100), 100)
    : 0;

  return (
    <div className="App">
      <div className="container">
        <header className="header">
          <h1>📊 Apollo Data Extraction Tool</h1>
          <p>Fetch, View, and Export Company Data</p>
        </header>

        {/* Search Form */}
        <div className="search-form">
          <div className="form-group">
            <label htmlFor="industry">Industry</label>
            <input
              id="industry" type="text" className="form-input"
              placeholder="e.g. Medical Devices"
              value={industry} onChange={e => setIndustry(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="region">Region</label>
              <select
                id="region" className="form-input"
                value={region}
                onChange={e => { setRegion(e.target.value); setCountry(''); setState(''); }}
                disabled={loading}
              >
                <option value="">All Regions</option>
                <option value="North America">North America</option>
                <option value="Europe">Europe</option>
                <option value="APAC">APAC</option>
                <option value="LA">LA (Latin America)</option>
                <option value="MEA">MEA (Middle East & Africa)</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="country">Country</label>
              <select
                id="country" className="form-input"
                value={country}
                onChange={e => { setCountry(e.target.value); setState(''); }}
                disabled={loading || !region}
              >
                <option value="">All Countries</option>
                {region && REGION_COUNTRIES[region] && REGION_COUNTRIES[region].map(c => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>

            {country && COUNTRY_STATES[country] && (
              <div className="form-group">
                <label htmlFor="state">State / Province</label>
                <select
                  id="state" className="form-input"
                  value={state}
                  onChange={e => setState(e.target.value)}
                  disabled={loading}
                >
                  <option value="">All States</option>
                  {COUNTRY_STATES[country].map(s => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              </div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="keywords">
              Keywords <span className="label-hint">(comma-separated, optional)</span>
            </label>
            <textarea
              id="keywords" className="form-textarea"
              placeholder="e.g. medical devices, medtech, surgical instruments..."
              value={keywords} onChange={e => setKeywords(e.target.value)}
              disabled={loading} rows={3}
            />
            {keywords && (
              <span className="keyword-count">
                {parseList(keywords).length} keyword{parseList(keywords).length !== 1 ? 's' : ''}
              </span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="excludeKeywords" className="label-exclude">
              Exclude <span className="label-hint">(comma-separated — company names, keywords or industries to skip)</span>
            </label>
            <textarea
              id="excludeKeywords" className="form-textarea form-textarea-exclude"
              placeholder="e.g. Google, consumer electronics, retail..."
              value={excludeKeywords} onChange={e => setExcludeKeywords(e.target.value)}
              disabled={loading} rows={2}
            />
            {excludeKeywords && (
              <span className="keyword-count exclude-count">
                {parseList(excludeKeywords).length} term{parseList(excludeKeywords).length !== 1 ? 's' : ''} excluded
              </span>
            )}
          </div>

        </div>

        {/* Controls */}
        <div className="controls">
          <button className="btn btn-primary"
            onClick={() => fetchCompanies(1, pagination.perPage)}
            disabled={loading}>
            {loading ? 'Fetching...' : '🔄 Fetch Data'}
          </button>

          {pagination.totalRecords > 0 && (
            <button className="btn btn-secondary"
              onClick={handlePrepareChunks}
              disabled={loading || exportLoading}>
              {exportLoading
                ? `⏳ ${exportProgress.fetched.toLocaleString()} / ${exportProgress.total.toLocaleString()} (${pct}%)`
                : `📦 Prepare Chunks (${pagination.totalRecords.toLocaleString()} records · ~${Math.ceil(pagination.totalRecords / 10000)} chunks)`}
            </button>
          )}

          {companies.length > 0 && (
            <div className="stats">
              <span>Records per page:</span>
              <select value={pagination.perPage} onChange={handlePerPageChange} disabled={loading}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={200}>200</option>
                <option value={500}>500</option>
              </select>
            </div>
          )}
        </div>

        {/* Export progress bar */}
        {exportLoading && (
          <div className="export-progress-bar-wrapper">
            <div className="export-progress-header">
              <span className="export-progress-label">📥 Preparing chunks…</span>
              <span className="export-progress-label"><strong>{pct}%</strong> — {exportProgress.fetched.toLocaleString()} / {exportProgress.total.toLocaleString()} records</span>
            </div>
            <div className="export-progress-track">
              <div className="export-progress-fill" style={{ width: `${pct}%` }} />
            </div>
          </div>
        )}

        {/* Chunk list */}
        {chunks.length > 0 && (
          <div className="chunk-list-wrapper">
            <div className="chunk-list-header">
              <div>
                <h3 className="chunk-list-title">📂 Chunk List</h3>
                <p className="chunk-list-subtitle">
                  {chunks.length} chunk{chunks.length !== 1 ? 's' : ''} ready
                  {exportLoading ? ' (still fetching…)' : ' · all data prepared'}
                  &nbsp;·&nbsp;
                  <strong>{totalChunkRecords.toLocaleString()}</strong> records fetched
                  &nbsp;·&nbsp;
                  <span className="chunk-downloaded-count">{downloadedCount} downloaded</span>
                  &nbsp;·&nbsp;
                  <span className="chunk-ready-count">{readyCount} remaining</span>
                </p>
              </div>
              {readyCount > 0 && !exportLoading && (
                <button className="btn btn-download-all" onClick={handleDownloadAllChunks}>
                  ⬇ Download All Remaining ({readyCount})
                </button>
              )}
            </div>

            <div className="chunk-list">
              {chunks.map(chunk => (
                <div key={chunk.chunkNum} className={`chunk-item ${chunk.status}`}>
                  <div className="chunk-info">
                    <span className="chunk-number">Chunk {chunk.chunkNum}</span>
                    <span className="chunk-records">{chunk.records.length.toLocaleString()} records</span>
                    <span className={`chunk-status-badge ${chunk.status}`}>
                      {chunk.status === 'downloaded' ? '✅ Downloaded' : '🟢 Ready'}
                    </span>
                  </div>
                  <div className="chunk-filename">
                    {baseFilename}_chunk_{chunk.chunkNum}_of_{chunk.totalChunks}.csv
                  </div>
                  <button
                    className={`btn chunk-download-btn ${chunk.status === 'downloaded' ? 'btn-redownload' : 'btn-download'}`}
                    onClick={() => handleDownloadChunk(chunk.chunkNum)}
                  >
                    {chunk.status === 'downloaded' ? '↩ Re-download' : '⬇ Download'}
                  </button>
                </div>
              ))}
              {exportLoading && (
                <div className="chunk-item fetching">
                  <div className="chunk-info">
                    <span className="chunk-number">Chunk {chunks.length + 1}</span>
                    <span className="chunk-records">Fetching…</span>
                    <span className="chunk-status-badge fetching">⏳ In Progress</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {error && <div className="error-message">❌ {error}</div>}
        {loading && <LoadingSpinner />}

        {!loading && companies.length > 0 && (
          <>
            <div className="table-toolbar">
              <div className="stats">
                <h3>📈 Total Records: <span className="count">{pagination.totalRecords.toLocaleString()}</span></h3>
                <p>
                  Showing {displayedCompanies.length.toLocaleString()}
                  {searchQuery ? ` of ${companies.length.toLocaleString()} on this page` : ` of ${pagination.totalRecords.toLocaleString()}`}
                  {revenueSort && <span className="sort-indicator"> · Revenue {revenueSort === 'asc' ? '▲ Low→High' : '▼ High→Low'}</span>}
                </p>
              </div>
              <div className="table-search-wrapper">
                <input
                  type="text"
                  className="table-search-input"
                  placeholder="🔍 Search company name…"
                  value={searchQuery}
                  onChange={e => setSearchQuery(e.target.value)}
                />
                {searchQuery && (
                  <button className="table-search-clear" onClick={() => setSearchQuery('')}>✕</button>
                )}
              </div>
            </div>
            <CompaniesTable
              companies={displayedCompanies}
              revenueSort={revenueSort}
              onRevenueSort={handleRevenueSort}
            />
            {pagination.totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(pagination.page - 1)}
                  disabled={pagination.page === 1 || loading}>← Previous</button>
                <span className="page-info">Page {pagination.page} of {pagination.totalPages}</span>
                <button onClick={() => handlePageChange(pagination.page + 1)}
                  disabled={pagination.page === pagination.totalPages || loading}>Next →</button>
              </div>
            )}
          </>
        )}

        {!loading && companies.length === 0 && !error && (
          <div className="empty-state">
            <p>Enter an industry and keywords, then click "Fetch Data"</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
